<h2 mat-dialog-title>Cambiar contraseña</h2>

<mat-dialog-content>
  @if (successMessage(); as message) {
    <p class="password-message password-success" role="status">{{ message }}</p>
  } @else {
    <p class="password-guidance">{{ passwordGuidance }}</p>

    @if (errorMessage(); as message) {
      <p class="password-message password-error" role="alert">{{ message }}</p>
    }

    <form id="change-password-form" [formGroup]="form" (ngSubmit)="submit()">
      <mat-form-field appearance="outline">
        <mat-label>Contraseña actual</mat-label>
        <input matInput type="password" formControlName="currentPassword" autocomplete="current-password" />
        @if (form.controls.currentPassword.touched && form.controls.currentPassword.invalid) {
          <mat-error>Ingresa tu contraseña actual.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Nueva contraseña</mat-label>
        <input matInput type="password" formControlName="newPassword" autocomplete="new-password" />
        @if (form.controls.newPassword.touched && form.controls.newPassword.invalid) {
          <mat-error>La contraseña no cumple la política mínima.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Confirmar nueva contraseña</mat-label>
        <input matInput type="password" formControlName="confirmation" autocomplete="new-password" />
        @if (form.controls.confirmation.touched && form.controls.confirmation.invalid) {
          <mat-error>Confirma la nueva contraseña.</mat-error>
        }
      </mat-form-field>
    </form>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (successMessage()) {
    <button mat-flat-button type="button" [mat-dialog-close]="true">Listo</button>
  } @else {
    <button mat-button type="button" [mat-dialog-close]="true" [disabled]="loading()">Cerrar</button>
    <button mat-flat-button type="submit" form="change-password-form" [disabled]="loading()">
      @if (loading()) {
        <mat-spinner diameter="18" aria-label="Cambiando contraseña" />
        Procesando
      } @else {
        Cambiar contraseña
      }
    </button>
  }
</mat-dialog-actions>
